module.exports = __webpack_public_path__ + "img/SKMJ_etc4.64f03a01.jpg";